import { useEffect, useState, useCallback } from 'react';
import { isEVMChain } from '../../wallet/chains';
import { initEvmProvider } from '../evm/evm-provider-init';
import { initSvmProvider } from '../svm/svm-provider-init';
export function useProviderInit({ toast, svmWallet, updateAllSVMChains }) {
    const [initStatus, setInitStatus] = useState({});
    useEffect(() => {
        initSvmProvider(svmWallet, () => updateAllSVMChains(false), toast).then(() => {
            setInitStatus((prev) => ({ ...prev, svm: true }));
        });
        initEvmProvider(toast).then(() => {
            setInitStatus((prev) => ({ ...prev, evm: true }));
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const isInitingStatus = useCallback((chain) => {
        if (isEVMChain(chain) && !initStatus.evm)
            return true;
        if (!isEVMChain(chain) && !initStatus.svm)
            return true;
        return false;
    }, [initStatus]);
    return { initStatus, isInitingStatus };
}
